export let notes = [
    {
        title: "Spice level",
        text: "This recipe calls for <i>1 tsp of dried red pepper flakes</i>. It packs a decent amount of heat, but doesn’t overpower the palate. Of course, if you are sensitive to spicy foods, decrease the quantity to <i>½ tsp or less</i>, and simply adjust to taste."
    }
]